
// add class on click module
function AddClass(opt) {
    this.options = lib.extend({
        item: null,
        classAdd: 'add-class',
        addToParent: false,
        event: 'click'
    }, opt);
    if (this.options.item) {
        this.item = this.options.item;
        this.classItem = this.item;
        if (this.options.addToParent) {
            if (typeof this.options.addToParent === 'boolean') {
                this.classItem = this.item.parentNode;
            } else {
                while (this.classItem.parentNode) {
                    if (lib.hasClass(this.classItem.parentNode, this.options.addToParent)) {
                        this.classItem = this.classItem.parentNode;
                        break;
                    }
                    this.classItem = this.classItem.parentNode;
                }
            }
        }
        this.attachEvents();
    }
}
AddClass.prototype = {
    attachEvents: function () {
        var self = this;
        lib.event.add(this.item, this.options.event, function (e) {
            self.toggleClass();
            e.preventDefault();
        });
    },
    toggleClass: function () {
        if (lib.hasClass(this.classItem, this.options.classAdd)) {
            lib.removeClass(this.classItem, this.options.classAdd);
        } else {
            lib.addClass(this.classItem, this.options.classAdd);
        }
    }
};

// DOM ready handler
function bindReady(handler) {
    var called = false;
    var ready = function () {
        if (called) return;
        called = true;
        handler();
    };
    if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', ready, false);
    } else if (document.attachEvent) {
        if (document.documentElement.doScroll && window == window.top) {
            var tryScroll = function () {
                if (called) return;
                if (!document.body) return;
                try {
                    document.documentElement.doScroll('left');
                    ready();
                } catch (e) {
                    setTimeout(tryScroll, 0);
                }
            };
            tryScroll();
        }
        document.attachEvent('onreadystatechange', function () {
            if (document.readyState === 'complete') {
                ready();
            }
        });
    }
    if (window.addEventListener) window.addEventListener('load', ready, false);
    else if (window.attachEvent) window.attachEvent('onload', ready);
}

/*
 * Form Validation
 */
;(function ($, window) {
    'use strict';

    var win = $(window),
        regEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
        regPhone = /^[0-9]+$/;

    function DarwinFormValidation(options) {
        this.options = $.extend(true, {
            errorClass: 'error',
            successClass: 'success',
            inputs: 'input, textarea, select',
            errorHolder: '.input-holder',
            ignoreClass: 'ignore',
            validationRules: {
                '.required': {
                    isError: function (currentObject) {
                        return !currentObject.val().length || currentObject.val() === currentObject.prop('defaultValue');
                    },
                    errorClass: 'input-error'
                },
                '[data-regexp]': {
                    isError: function (currentObject) {
                        return !(new RegExp(currentObject.data('regexp')).test(currentObject.val()));
                    }
                },
                '.required-email': {
                    isError: function (currentObject) {
                        return !regEmail.test(currentObject.val());
                    }
                },
                '.required-number': {
                    isError: function (currentObject) {
                        return !regPhone.test(currentObject.val());
                    }
                },
                '.required-select': {
                    isError: function (currentObject) {
                        return currentObject.get(0).selectedIndex === 0;
                    }
                }
            }
        }, options);
        this.init();
    }

    DarwinFormValidation.prototype = {
        init: function () {
            if (this.options.form) {
                this.findElements();
                this.attachEvents();
                this.makeCallback('onInit', this);
            }
        },
        findElements: function () {
            // find elements
            this.form = $(this.options.form).attr('novalidate', 'novalidate');
            this.inputs = this.form.find(this.options.inputs);
            this.allErrorClasses = this.getAllErrorClasses();
            this.successFlag = true;
        },
        attachEvents: function () {
            var self = this;
            this.bindHandlers();
            this.form.on('submit', this.onSubmitHandler);
        },
        getAllErrorClasses: function () {
            var classes = '';
            $.each(this.options.validationRules, function (ind, obj) {
                if (obj.errorClass) {
                    classes += obj.errorClass + ' ';
                }
            });
            return classes;
        },
        checkField: function (field) {
            var self = this;
            var currentObject = jQuery(field);
            var currentParent = currentObject.closest(this.options.errorHolder);

            for (var ruleClass in this.options.validationRules) {
                (function (ruleClass) {
                    var isError;
                    var obj = self.options.validationRules[ruleClass];
                    if (currentObject.filter(ruleClass).length) {
                        isError = obj.isError(currentObject);
                        self.makeCallback('onFieldValidate', currentObject, isError);
                        self.setState(currentParent, currentObject, {
                            isError: isError,
                            errorClass: obj.errorClass
                        });
                        if (isError) return false;
                    }
                })(ruleClass);
            }
        },
        setState: function (hold, field, error) {
            var self = this;
            hold
                .removeClass(this.options.errorClass)
                .removeClass(this.options.successClass)
                .removeClass(this.allErrorClasses)
                .removeClass('ajax-validation-error');

            if (error.isError) {
                hold.addClass(error.errorClass || this.options.errorClass);
                field.one('focus change', function () {
                    hold
                        .removeClass(self.options.errorClass)
                        .removeClass(self.options.successClass)
                        .removeClass(self.allErrorClasses)
                        .removeClass('ajax-validation-error');
                });
                this.successFlag = false;
            } else {
                hold.addClass(this.options.successClass);
            }
        },
        onSubmitHandler: function (e) {
            var self = this;
            this.successFlag = true;
            this.inputs.each(function () {
                if (jQuery(this).closest('.' + self.options.ignoreClass).length === 0) {
                    self.checkField(this);
                }
            });
            if (!this.successFlag) {
                e.preventDefault();
            }
            this.makeCallback('onSubmit', this);
        },
        bindHandlers: function () {
            var self = this;
            $.each(self, function (propName, propValue) {
                if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
                    self[propName] = function () {
                        return propValue.apply(self, arguments);
                    };
                }
            });
        },
        makeCallback: function (name) {
            var args;
            if (typeof this.options[name] === 'function') {
                args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        }
    };

    // jQuery plugin interface
    $.fn.darwinFormValidation = function (options) {
        return this.each(function () {
            var params = $.extend({}, options, {form: this}),
                instance = new DarwinFormValidation(params);
            $.data(this, 'DarwinFormValidation', instance);
        });
    };

    // module exports
    window.DarwinFormValidation = DarwinFormValidation;
}(jQuery, window));

/*
 * jQuery Tabs plugin
 */
;(function ($, $win) {

    'use strict';

    function Tabset($holder, options) {
        this.$holder = $holder;
        this.options = options;

        this.init();
    }

    Tabset.prototype = {
        init: function () {
            this.$tabLinks = this.$holder.find(this.options.tabLinks);

            this.setStartActiveIndex();
            this.setActiveTab();

            if (this.options.autoHeight) {
                this.$tabHolder = $(this.$tabLinks.eq(0).attr(this.options.attrib)).parent();
            }

            this.makeCallback('onInit', this);
        },

        setStartActiveIndex: function () {
            var $classTargets = this.getClassTarget(this.$tabLinks);
            var $activeLink = $classTargets.filter('.' + this.options.activeClass);
            var $hashLink = this.$tabLinks.filter('[' + this.options.attrib + '="' + location.hash + '"]');
            var activeIndex;

            if (this.options.checkHash && $hashLink.length) {
                $activeLink = $hashLink;
            }

            activeIndex = $classTargets.index($activeLink);

            this.activeTabIndex = this.prevTabIndex = (activeIndex === -1 ? (this.options.defaultTab ? 0 : null) : activeIndex);
        },

        setActiveTab: function () {
            var self = this;

            this.$tabLinks.each(function (i, link) {
                var $link = $(link);
                var $classTarget = self.getClassTarget($link);
                var $tab = $($link.attr(self.options.attrib));

                if (i !== self.activeTabIndex) {
                    $classTarget.removeClass(self.options.activeClass);
                    $tab.addClass(self.options.tabHiddenClass).removeClass(self.options.activeClass);
                } else {
                    $classTarget.addClass(self.options.activeClass);
                    $tab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);
                }

                self.attachTabLink($link, i);
            });
        },

        attachTabLink: function ($link, i) {
            var self = this;

            $link.on(this.options.event + '.tabset', function (e) {
                e.preventDefault();

                if (self.activeTabIndex === self.prevTabIndex && self.activeTabIndex !== i) {
                    self.activeTabIndex = i;
                    self.switchTabs();
                }
            });
        },

        resizeHolder: function (height) {
            var self = this;

            if (height) {
                this.$tabHolder.height(height);
                setTimeout(function () {
                    self.$tabHolder.addClass('transition');
                }, 10);
            } else {
                self.$tabHolder.removeClass('transition').height('');
            }
        },

        switchTabs: function () {
            var self = this;

            var $prevLink = this.$tabLinks.eq(this.prevTabIndex);
            var $nextLink = this.$tabLinks.eq(this.activeTabIndex);

            var $prevTab = this.getTab($prevLink);
            var $nextTab = this.getTab($nextLink);

            $prevTab.removeClass(this.options.activeClass);

            if (self.haveTabHolder()) {
                this.resizeHolder($prevTab.outerHeight());
            }

            setTimeout(function () {
                self.getClassTarget($prevLink).removeClass(self.options.activeClass);

                $prevTab.addClass(self.options.tabHiddenClass);
                $nextTab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);

                self.getClassTarget($nextLink).addClass(self.options.activeClass);

                if (self.haveTabHolder()) {
                    self.resizeHolder($nextTab.outerHeight());

                    setTimeout(function () {
                        self.resizeHolder();
                        self.prevTabIndex = self.activeTabIndex;
                        self.makeCallback('onChange', self);
                    }, self.options.animSpeed);
                } else {
                    self.prevTabIndex = self.activeTabIndex;
                }
            }, this.options.autoHeight ? this.options.animSpeed : 1);
        },

        getClassTarget: function ($link) {
            return this.options.addToParent ? $link.parent() : $link;
        },

        getActiveTab: function () {
            return this.getTab(this.$tabLinks.eq(this.activeTabIndex));
        },

        getTab: function ($link) {
            return $($link.attr(this.options.attrib));
        },

        haveTabHolder: function () {
            return this.$tabHolder && this.$tabHolder.length;
        },

        destroy: function () {
            var self = this;

            this.$tabLinks.off('.tabset').each(function () {
                var $link = $(this);

                self.getClassTarget($link).removeClass(self.options.activeClass);
                $($link.attr(self.options.attrib)).removeClass(self.options.activeClass + ' ' + self.options.tabHiddenClass);
            });

            this.$holder.removeData('Tabset');
        },

        makeCallback: function (name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        }
    };

    $.fn.tabset = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        var options = $.extend({
            activeClass: 'active',
            addToParent: false,
            autoHeight: false,
            checkHash: false,
            defaultTab: true,
            animSpeed: 500,
            tabLinks: 'a',
            attrib: 'href',
            event: 'click',
            tabHiddenClass: 'js-tab-hidden'
        }, opt);
        options.autoHeight = options.autoHeight && $.support.opacity;

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('Tabset');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $holder.data('Tabset', new Tabset($holder, options));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery, jQuery(window)));

/*
 * jQuery Open/Close plugin
 */
;(function ($) {
    function OpenClose(options) {
        this.options = $.extend({
            addClassBeforeAnimation: true,
            hideOnClickOutside: false,
            activeClass: 'active',
            opener: '.opener',
            slider: '.slide',
            animSpeed: 400,
            effect: 'fade',
            event: 'click'
        }, options);
        this.init();
    }

    OpenClose.prototype = {
        init: function () {
            if (this.options.holder) {
                this.findElements();
                this.attachEvents();
                this.makeCallback('onInit', this);
            }
        },
        findElements: function () {
            this.holder = $(this.options.holder);
            this.opener = this.holder.find(this.options.opener);
            this.slider = this.holder.find(this.options.slider);
        },
        attachEvents: function () {
            // add handler
            var self = this;
            this.eventHandler = function (e) {
                e.preventDefault();
                if (self.slider.hasClass(slideHiddenClass)) {
                    self.showSlide();
                } else {
                    self.hideSlide();
                }
            };
            self.opener.on(self.options.event, this.eventHandler);

            // hover mode handler
            if (self.options.event === 'over') {
                self.opener.on('mouseenter', function () {
                    if (!self.holder.hasClass(self.options.activeClass)) {
                        self.showSlide();
                    }
                });
                self.holder.on('mouseleave', function () {
                    self.hideSlide();
                });
            }

            // outside click handler
            self.outsideClickHandler = function (e) {
                if (self.options.hideOnClickOutside) {
                    var target = $(e.target);
                    if (!target.is(self.holder) && !target.closest(self.holder).length) {
                        self.hideSlide();
                    }
                }
            };

            // set initial styles
            if (this.holder.hasClass(this.options.activeClass)) {
                $(document).on('click touchstart', self.outsideClickHandler);
            } else {
                this.slider.addClass(slideHiddenClass);
            }
        },
        showSlide: function () {
            var self = this;
            if (self.options.addClassBeforeAnimation) {
                self.holder.addClass(self.options.activeClass);
            }
            self.slider.removeClass(slideHiddenClass);
            $(document).on('click touchstart', self.outsideClickHandler);

            self.makeCallback('animStart', true);
            toggleEffects[self.options.effect].show({
                box: self.slider,
                speed: self.options.animSpeed,
                complete: function () {
                    if (!self.options.addClassBeforeAnimation) {
                        self.holder.addClass(self.options.activeClass);
                    }
                    self.makeCallback('animEnd', true);
                }
            });
        },
        hideSlide: function () {
            var self = this;
            if (self.options.addClassBeforeAnimation) {
                self.holder.removeClass(self.options.activeClass);
            }
            $(document).off('click touchstart', self.outsideClickHandler);

            self.makeCallback('animStart', false);
            toggleEffects[self.options.effect].hide({
                box: self.slider,
                speed: self.options.animSpeed,
                complete: function () {
                    if (!self.options.addClassBeforeAnimation) {
                        self.holder.removeClass(self.options.activeClass);
                    }
                    self.slider.addClass(slideHiddenClass);
                    self.makeCallback('animEnd', false);
                }
            });
        },
        destroy: function () {
            this.slider.removeClass(slideHiddenClass).css({
                display: ''
            });
            this.opener.off(this.options.event, this.eventHandler);
            this.holder.removeClass(this.options.activeClass).removeData('OpenClose');
            $(document).off('click touchstart', this.outsideClickHandler);
        },
        makeCallback: function (name) {
            if (typeof this.options[name] === 'function') {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        }
    };

    // add stylesheet for slide on DOMReady
    var slideHiddenClass = 'js-slide-hidden';
    (function () {
        var tabStyleSheet = $('<style type="text/css">')[0];
        var tabStyleRule = '.' + slideHiddenClass;
        tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}';
        if (tabStyleSheet.styleSheet) {
            tabStyleSheet.styleSheet.cssText = tabStyleRule;
        } else {
            tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
        }
        $('head').append(tabStyleSheet);
    }());

    // animation effects
    var toggleEffects = {
        slide: {
            show: function (o) {
                o.box.stop(true).hide().slideDown(o.speed, o.complete);
            },
            hide: function (o) {
                o.box.stop(true).slideUp(o.speed, o.complete);
            }
        },
        fade: {
            show: function (o) {
                o.box.stop(true).hide().fadeIn(o.speed, o.complete);
            },
            hide: function (o) {
                o.box.stop(true).fadeOut(o.speed, o.complete);
            }
        },
        none: {
            show: function (o) {
                o.box.hide().show(0, o.complete);
            },
            hide: function (o) {
                o.box.hide(0, o.complete);
            }
        }
    };

    // jQuery plugin interface
    $.fn.openClose = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('OpenClose');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                $holder.data('OpenClose', new OpenClose($.extend({
                    holder: this
                }, opt)));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery));

/*
 * jQuery Load More plugin
 */
;(function ($, $win) {
    'use strict';

    var ScrollLoader = {
        attachEvents: function () {
            var self = this;

            $win.on('load.ScrollLoader resize.ScrollLoader orientationchange.ScrollLoader', function () {
                self.onResizeHandler();
            });
            $win.on('scroll.ScrollLoader', function () {
                self.onScrollHandler();
            });
            this.$holder.on('ContentLoader/loaded.ScrollLoader', function () {
                self.onResizeHandler();
            });

            this.winProps = {};
            this.holderProps = {};
            this.onResizeHandler();
        },

        onResizeHandler: function () {
            this.winProps.height = $win.height();
            this.holderProps.height = this.$holder.outerHeight();
            this.holderProps.offset = this.$holder.offset().top;

            this.onScrollHandler();
        },

        onScrollHandler: function () {
            this.winProps.scroll = $win.scrollTop();

            if (this.winProps.scroll + this.winProps.height + Math.min(1, this.options.additionBottomOffset) > this.holderProps.height + this.holderProps.offset) {
                this.loadInclude();
            }
        },

        destroySubEvents: function () {
            $win.off('.ScrollLoader');
            this.$holder.off('.ScrollLoader');
        }
    };

    var ClickLoader = {
        attachEvents: function () {
            var self = this;

            this.$holder.on('click.ClickLoader', this.options.linkSelector, function (e) {
                self.onClickHandler(e);
            });
        },

        onClickHandler: function (e) {
            e.preventDefault();

            this.loadInclude();
        },

        destroySubEvents: function () {
            this.$holder.off('.ClickLoader');
        }
    };

    var ContentLoader = function ($holder, options) {
        this.$holder = $holder;
        this.options = options;

        this.init();
    };

    var ContentLoaderProto = {
        init: function () {
            this.$link = this.$holder.find(this.options.linkSelector);
            this.$newContentTarget = this.options.newContentTarget ? this.$holder.find(this.options.newContentTarget) : this.$holder;

            if (!this.$link.length) {
                this.removeInstance();
                return;
            }

            this.attachEvents();
        },

        loadInclude: function () {
            if (this.isBusy) {
                return;
            }

            var self = this;

            this.toggleBusyMode(true);

            $.get(self.$link.attr('href'), function (source) {
                self.successHandler(source);
            });
        },

        successHandler: function (include) {
            var $tmpDiv = jQuery('<div>').html(include);
            var $nextIncludeLink = $tmpDiv.find(this.options.linkSelector);

            if ($nextIncludeLink.length) {
                this.refreshLink($nextIncludeLink);
            } else {
                this.destroy();
            }

            this.appendItems($tmpDiv.children());
        },

        appendItems: function ($newItems) {
            var self = this;

            this.$newContentTarget.append($newItems.addClass(this.options.preAppendClass));

            setTimeout(function () { // need this timeout coz need some time for css preAppendClass applied to the new items
                $newItems.removeClass(self.options.preAppendClass);

                self.$holder.trigger('ContentLoader/loaded');
                self.toggleBusyMode(false);
            }, 100);

            if (window.picturefill) {
                window.picturefill();
            }
        },

        refreshLink: function ($nextIncludeLink) {
            this.$link.attr('href', $nextIncludeLink.attr('href'));
            $nextIncludeLink.remove();
        },

        toggleBusyMode: function (state) {
            this.$holder.toggleClass(this.options.busyClass, state);
            this.isBusy = state;
        },

        removeInstance: function () {
            this.$holder.removeData('ContentLoader');
        },

        destroy: function () {
            this.removeInstance();
            this.destroySubEvents();

            this.$link.remove();
        }
    };

    $.fn.loadMore = function (opt) {
        var args = Array.prototype.slice.call(arguments);
        var method = args[0];

        var options = $.extend({
            scroll: false,
            linkSelector: '.load-more',
            newContentTarget: null,
            busyClass: 'is-busy',
            additionBottomOffset: 50,
            preAppendClass: 'new-item'
        }, opt);

        return this.each(function () {
            var $holder = jQuery(this);
            var instance = $holder.data('ContentLoader');

            if (typeof opt === 'object' || typeof opt === 'undefined') {
                ContentLoader.prototype = $.extend(options.scroll ? ScrollLoader : ClickLoader, ContentLoaderProto);

                $holder.data('ContentLoader', new ContentLoader($holder, options));
            } else if (typeof method === 'string' && instance) {
                if (typeof instance[method] === 'function') {
                    args.shift();
                    instance[method].apply(instance, args);
                }
            }
        });
    };
}(jQuery, jQuery(window)));

/*
 * Responsive Layout helper
 */
window.ResponsiveHelper = (function ($) {
    // init variables
    var handlers = [],
        prevWinWidth,
        win = $(window),
        nativeMatchMedia = false;

    // detect match media support
    if (window.matchMedia) {
        if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
            nativeMatchMedia = true;
        } else if (window.matchMedia.toString().indexOf('native') > -1) {
            nativeMatchMedia = true;
        }
    }

    // prepare resize handler

    function resizeHandler() {
        var winWidth = win.width();
        if (winWidth !== prevWinWidth) {
            prevWinWidth = winWidth;

            // loop through range groups
            $.each(handlers, function (index, rangeObject) {
                // disable current active area if needed
                $.each(rangeObject.data, function (property, item) {
                    if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
                        item.currentActive = false;
                        if (typeof item.disableCallback === 'function') {
                            item.disableCallback();
                        }
                    }
                });

                // enable areas that match current width
                $.each(rangeObject.data, function (property, item) {
                    if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
                        // make callback
                        item.currentActive = true;
                        if (typeof item.enableCallback === 'function') {
                            item.enableCallback();
                        }
                    }
                });
            });
        }
    }

    win.bind('load resize orientationchange', resizeHandler);

    // test range
    function matchRange(r1, r2) {
        var mediaQueryString = '';
        if (r1 > 0) {
            mediaQueryString += '(min-width: ' + r1 + 'px)';
        }
        if (r2 < Infinity) {
            mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
        }
        return matchQuery(mediaQueryString, r1, r2);
    }

    // media query function
    function matchQuery(query, r1, r2) {
        if (window.matchMedia && nativeMatchMedia) {
            return matchMedia(query).matches;
        } else if (window.styleMedia) {
            return styleMedia.matchMedium(query);
        } else if (window.media) {
            return media.matchMedium(query);
        } else {
            return prevWinWidth >= r1 && prevWinWidth <= r2;
        }
    }

    // range parser
    function parseRange(rangeStr) {
        var rangeData = rangeStr.split('..');
        var x1 = parseInt(rangeData[0], 10) || -Infinity;
        var x2 = parseInt(rangeData[1], 10) || Infinity;
        return [x1, x2].sort(function (a, b) {
            return a - b;
        });
    }

    // export public functions
    return {
        addRange: function (ranges) {
            // parse data and add items to collection
            var result = {data: {}};
            $.each(ranges, function (property, data) {
                result.data[property] = {
                    range: parseRange(property),
                    enableCallback: data.on,
                    disableCallback: data.off
                };
            });
            handlers.push(result);

            // call resizeHandler to recalculate all events
            prevWinWidth = null;
            resizeHandler();
        }
    };
}(jQuery));

